<template>
  <a-modal
    v-model:visible="modalConfig.visible"
    :title="modalConfig.title"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form
      :model="formState"
      ref="formRef"
      :rules="rules"
      :label-col="{ span: 4 }"
    >
      <a-form-item label="昵称" name="nickName">
        <a-input
          v-model:value="formState.nickName"
          placeholder="请输入昵称"
          @change="handleUpdateUserName"
        ></a-input>
      </a-form-item>

      <a-form-item label="工号" name="jobNumber">
        <a-input
          v-model:value="formState.jobNumber"
          placeholder="请输入工号"
          @change="handleUpdateUserName"
        ></a-input>
      </a-form-item>

      <a-form-item label="职位" name="post">
        <a-input
          v-model:value="formState.post"
          placeholder="请输入职位"
        ></a-input>
      </a-form-item>
      <a-form-item label="入职时间" name="entryTime">
        <a-date-picker
          v-model:value="formState.entryTime"
          @change="handleSelectEntryTime"
        ></a-date-picker>
      </a-form-item>

      <a-form-item label="所属部门" name="structureId">
        <case-depart-ment
          :echoVal="formState.structureId"
          :clear="modalConfig.visible"
          @selectSuperiorDepartment="selectSuperiorDepartment"
        ></case-depart-ment>
      </a-form-item>

      <a-form-item label="部门领导" name="isDL">
        <a-switch
          checked-children="是"
          un-checked-children="否"
          v-model:checked="formState.isDL"
        />
      </a-form-item>

      <a-form-item label="一级部门">
        <a-input
          v-model:value="formState.firstLevelDepartment"
          disabled
        ></a-input>
      </a-form-item>

      <a-form-item label="二级部门">
        <a-input
          v-model:value="formState.secondaryDepartment"
          disabled
        ></a-input>
      </a-form-item>

      <a-form-item label="直属领导" name="reportTo">
        <a-input
          v-model:value="formState.reportTo"
          placeholder="请输入直属领导"
        ></a-input>
      </a-form-item>

      <a-form-item label="登录账号" name="username">
        <a-input
          v-model:value="formState.username"
          placeholder="请输入登录账号"
          disabled
        ></a-input>
      </a-form-item>

      <a-form-item label="登录密码" name="password">
        <a-input
          type="password"
          v-model:value="formState.password"
          placeholder="请输入登录密码"
        ></a-input>
      </a-form-item>

      <a-form-item label="备注" name="notes">
        <a-textarea
          v-model:value="formState.notes"
          placeholder="请输入备注"
          auto-size
        >
        </a-textarea>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
   
<script>
import { defineComponent, reactive, ref } from "vue";
import { saveOrUpdateUser } from "@/request/view/personal";
import caseDepartMent from "@/views/personnelManagement/component/department/caseDepartMent.vue";
import { Toast, debounce } from "@/utils";

export default defineComponent({
  components: { caseDepartMent },
  setup(props, context) {
    const modalConfig = reactive({
      visible: false,
      type: null,
      title: null,
    });

    const formState = reactive({
      custom: null,
      entryTime: null,
      firstLevelDepartment: null,
      id: null,
      isDL: false,
      jobNumber: null,
      nickName: null,
      notes: null,
      password: null,
      pid: null,
      post: null,
      reportTo: null,
      secondaryDepartment: null,
      structureId: null,
      username: null,
    });

    const validateStructureId = (rule, value) => {
      if (!formState.structureId) {
        return Promise.reject("请选择所属部门");
      }
      return Promise.resolve();
    };

    const rules = {
      entryTime: [
        {
          required: true,
          message: "请选择入职时间",
          trigger: "blur",
          type: "any",
        },
      ],
      jobNumber: [
        {
          required: true,
          message: "请输入工号",
          trigger: "blur",
          type: "string",
        },
      ],
      entryTime: [
        {
          required: true,
          message: "请选择入职时间",
          trigger: "blur",
          type: "string",
        },
      ],
      isDL: [
        {
          required: true,
          message: "请选择是否部门领导",
          trigger: "blur",
          type: "boolean",
        },
      ],
      nickName: [
        {
          required: true,
          message: "请输入昵称",
          trigger: "blur",
          type: "string",
        },
      ],
      username: [
        {
          required: true,
          message: "登录账号",
          trigger: "blur",
          type: "string",
        },
      ],
      password: [
        {
          required: true,
          message: "登录密码",
          trigger: "blur",
          type: "string",
        },
      ],
      structureId: [
        {
          required: true,
          message: "请选择所属部门",
          validator: validateStructureId,
          trigger: "blur",
          type: "string",
        },
      ],
      post: [
        {
          required: true,
          message: "请输入职位",
          trigger: "blur",
          type: "string",
        },
      ],
      reportTo: [
        {
          required: true,
          message: "请输入直属领导",
          trigger: "blur",
          type: "string",
        },
      ],
    };

    const resetFormData = () => {
      formRef.value.clearValidate();
      Object.keys(formState).forEach((key) => {
        formState[key] = null;
      });
      formState.isDL = false;
      modalConfig.type = null;
      modalConfig.title = null;
      modalConfig.visible = false;
    };

    const showModal = (options) => {
      const { title, type, data } = options;

      if (type === "update") {
        Object.keys(formState).forEach((key) => {
          formState[key] = data[key];
        });
      }

      modalConfig.title = title;
      modalConfig.type = type;
      modalConfig.visible = true;
    };

    const selectSuperiorDepartment = (key, department) => {
      formState.structureId = null;
      formState.firstLevelDepartment = null;
      formState.secondaryDepartment = null;
      if (key !== null && defineComponent.length !== 0) {
        formState.structureId = key;

        const [company, firstLevelDepartment, secondaryDepartment] = department;

        formState.firstLevelDepartment = firstLevelDepartment.structureName;

        if (secondaryDepartment) {
          formState.secondaryDepartment = secondaryDepartment.structureName;
        }
      }
    };

    const handleSelectEntryTime = (date, dateString) => {
      formState.entryTime = dateString;
    };

    const handleUpdateUserName = () => {
      if (formState.jobNumber && formState.nickName) {
        formState.username = `${formState.nickName}${formState.jobNumber}`;
      }
    };

    const formRef = ref();

    const handleOk = debounce(() => {
      formRef.value
        .validate()
        .then((res) => {
          saveOrUpdateUser(formState)
            .then((res) => {
              let type = res.code === 200 ? "success" : "warning";
              Toast(type, res.message, 3);
              context.emit("updateTable", modalConfig.type === "insert");
              resetFormData();
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    });

    const handleCancel = () => {
      resetFormData();
    };

    return {
      modalConfig,
      handleOk,
      showModal,
      handleUpdateUserName,
      handleSelectEntryTime,
      selectSuperiorDepartment,
      handleCancel,
      formState,
      formRef,
      rules,
    };
  },
});
</script>
   
<style lang="less" scoped>
</style>